import React,{ useState,useEffect  } from 'react';
import { connect } from 'react-redux';
import {  useLocation,useNavigate,Link } from 'react-router-dom';

import Logo  from '../../assets/rasun/logo1.png'
import Logo1  from '../../assets/icon/lp.png'
import bnbLogo  from '../../assets/icon/bnblogo.png'
import polygonLogo  from '../../assets/icon/polygon.png'
import './head.less';
import { message, Drawer,Space,Collapse   } from 'antd'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next';
import {init} from '../../utils/ethers'
import { CSSTransition } from 'react-transition-group';
import { 
    MenuOutlined,
    CheckOutlined,
    CaretRightOutlined,
    CloseOutlined,
    WarningOutlined,HomeOutlined, UserAddOutlined, ShareAltOutlined, WalletOutlined
    } from '@ant-design/icons'
import {login,register} from "../../api";

const { Panel } = Collapse;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        lan:state.lan,
        pAddress:state.pAddress,
        flash:state.flash
        
        
    }
}

const Head = (props) => {
    const { t } = useTranslation()
    const [isShowMenu,setIsShowMenu] = useState(false);
  const [showJoinBind,setShowJoinBind] = useState(false)
     const [puser,setPuser] = useState("")

    const [showTag,setShowTag]=useState(1)
const [isShowMenu1,setIsSHowMenu1] = useState(false)
    // const handleCancel = () =>{setIsShowMenu(false)}
  
    const showMenu = () =>{setIsShowMenu(!isShowMenu)}
    
    const location = useLocation()
    const { search} = location
    const navigate = useNavigate()//hook事件路由跳转

    
   
    let i=1;
    let iarr=[]
    iarr = search.split('?i=')
    if(iarr.length>1){
        i = iarr[1].slice(0,42)
    }
 

   
    
    if (i.length == 42){
        props.setPAddress(i)
         sessionStorage.setItem('i',i);  
    }
    // let sessioni=sessionStorage.getItem('i') || ""
    // if(i!==1){
    //     sessionStorage.setItem('i',i);  
    // }else{
    //     if(sessioni){
    //         i=sessioni;
    //     }else{
    //         sessionStorage.setItem('i',i); 
    //     }
    // }


    
    


     const changeLan = (e) =>{
        props.setLan(e)
        i18n.changeLanguage(e)
        setIsSHowMenu1(false)
        localStorage.setItem("lan",e)
      }

    const par1 = ()=>{
            navigator.clipboard.readText().then((text) => {
                if(text.length!=10){
                    message.error(t('head.地址格式不正确'))
                    return
                }
                props.setPAddress(text)
            }, () => {
                console.log('Paste failed');
            });
        }

    
    const _register = () =>{
  
        
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            let sessioni=sessionStorage.getItem('i') || ""
            if (sessioni.length == 42){
                
            }else{
                message.error(t('head.推荐人地址不能为空'))
                    return false
            }
            // if(props.pAddress.length==0 ){
            //     message.error(t('head.推荐人地址不能为空'))
            //     return false
            // }
            register({address:props.address,pAddress:sessioni}).then(res=>{
                if(res.code == 0){
                    message.success(t('head.绑定成功'))
                    setPuser(res.data.puser)
                    setShowJoinBind(false)
                    props.setIsLogin(true)
    
                }else{
                    message.error(res.msg)
                }
    
            })
        }
    

    const connectWallet = () =>{ 
        let sessioni=sessionStorage.getItem('i') || ""
        if (sessioni.length == 10){
            props.setPAddress(sessioni)
        }
        console.log(sessioni)
    //       const timestamp = parseInt(new Date().getTime() /1000);
    // console.log(timestamp)
                 
    // if(timestamp<1755603000){
    //     message.error(t('g.暂未开始'))
    //             return false
    // }
            init().then(
                res=>{
                    login({address:res.address,pass:res.pass}).then(res1=>{
                        if (res1.code == 0){
                            message.success(t('head.连接成功'))
                            //props.setIsLogin(res1.data.has)
                            if(!res1.data.has){
                                 go4()
                                message.warn(t('head.您还未绑定钱包，请绑定激活钱包地址'))
                                // props.setFlash(!props.flash)
                                return
                            }else{
                                props.setIsLogin(true)
                            }
                        }else{
                            props.setAddress("")
                            message.error(res1.msg)
                        }
                },err=>{
                    props.setAddress("")
                    message.error(t('head.连接失败')+"请检测您的网络环境")
                } )

            })
        
        
    }
 
    const go4 = ()=>{
        setIsShowMenu(false)

        navigate("/reg",{
            state:{
                address:props.address
            }
        })
    }

    const wei = ()=>{
        message.warn(t('mint.即将开放'))

        
    }
  
    const goLiushui = (url)=>{
        //     message.error(t('g.暂未开放'))
        //    return
           
            navigate(url)
        }
    
    
    useEffect(() => {
        // setTimeout(() => {
        //     connectWallet()
        // }, 2000);
        //  if(props.address.length>0 && !props.isLogin){
        //         props.setFlash(true)
        //     }

        
    }, 
    // eslint-disable-next-line
    []);
    
    return (
        <>
       
        <div   className='mm mx-auto w-full lg:w-1/3 flex flex-row justify-between items-center h-16  text-white px-3 fixed top-0 headzindex999' >
             <div onClick={showMenu} className=' w-1/12  text-white flex flex-row justify-center items-center text-base'>
                {
                    isShowMenu?(
                        <CloseOutlined  onClick={showMenu}/>
                    ):(
                        <MenuOutlined onClick={showMenu} />
                    )
                }
                

                
            </div>

            <div onClick={()=>goLiushui("/")} className='w-4/12 flex flex-row items-center justify-start -ml-4'>
                
                <img className='  mr-1' alt='logo' src={Logo}  style={{"width":"90px"}}></img>
                {/* <div className='flex flex-col justify-center items-center h-3'>
                    <span className=' text-base text-gray-200'>RADR</span>
                    <span className=' text-base text-gray-200'>On-chain</span>
                </div> */}
                
            </div>
            
            {/* <div  className='  w-2/12  flex flex-row justify-center items-center relative'>
            {
                    props.lan==='en'?(
                        <img onClick={()=>setIsSHowMenu1(!isShowMenu1)} alt='rr' className=' mr-1 ' src={require('../../assets/qi/q1.png')} style={{"width":"30px"}}></img>
                    ):props.lan==='rr'?(
                        <img onClick={()=>setIsSHowMenu1(!isShowMenu1)} alt='rr' className=' mr-1 ' src={require('../../assets/qi/q2.png')} style={{"width":"30px"}}></img>
                    ):props.lan==='zh'?(
                        <img  onClick={()=>setIsSHowMenu1(!isShowMenu1)} alt='rr' className=' mr-1 ' src={require('../../assets/qi/q3.png')} style={{"width":"30px"}}></img>
                    ):props.lan==='kr'?(
                        <img onClick={()=>setIsSHowMenu1(!isShowMenu1)} alt='rr' className=' mr-1 ' src={require('../../assets/qi/q5.png')} style={{"width":"30px"}}></img>
                    ):props.lan==='in'?(
                        <img onClick={()=>setIsSHowMenu1(!isShowMenu1)} alt='rr' className=' mr-1 ' src={require('../../assets/qi/q4.png')} style={{"width":"30px"}}></img>
                    ):null
                  }
                  
                    
                  <CSSTransition
                        in={isShowMenu1}
                        unmountOnExit={true}
                        classNames='guo'
                        timeout={500}
                        appear
                        onEnter={(e) => console.log('开始进入动画')}
                        onEntering={(e) => console.log('执行进入动画')}
                        onEntered={(e) => console.log('进入动画结束')}
                        onExit={(e) => console.log('开始离开动画')}
                        onExiting={(e) => console.log('正在离开动画')}
                        onExited={(e) => console.log('离开动画结束')}>
                            <div style={{"bottom":"-225px","backgroundColor":"#20150E"}} className=' w-10 mr-1 py-4  border border-head-border absolute  rounded-full flex flex-col items-center justify-center'>
                            <img onClick={()=>changeLan("en")} alt='rr' className='   ' src={require('../../assets/qi/q1.png')} style={{"width":"25px"}}></img>
                            <img onClick={()=>changeLan("rr")} alt='rr' className=' mt-4  ' src={require('../../assets/qi/q2.png')} style={{"width":"25px"}}></img>
                            <img onClick={()=>changeLan("zh")} alt='rr' className=' mt-4  ' src={require('../../assets/qi/q3.png')} style={{"width":"25px"}}></img>
                            <img onClick={()=>changeLan("in")} alt='rr' className=' mt-4 ' src={require('../../assets/qi/q4.png')} style={{"width":"25px"}}></img>
                            <img onClick={()=>changeLan("kr")} alt='rr' className=' mt-4  ' src={require('../../assets/qi/q5.png')} style={{"width":"25px"}}></img>
                </div>
                            </CSSTransition>                  
                
                                   
             </div> */}
            <div className=' w-6/12 flex flex-row justify-end items-center'>
            {
                    !props.address?(
                        <button style={{backgroundImage: 'linear-gradient(90deg, #CE0018 20%, #4F004E 100%)'}} onClick={connectWallet} className='px-8 h-8    text-[#ffffff] rounded-md  text-xs text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('head.连接钱包')}</span></button>
                    ):(
                        <button className=' w-4/5 h-8   bg-[#FC5F7B30]    text-[#FC5F7B]  rounded-md  font-extrabold text-xs text-center px-2 flex flex-row items-center' >
                            
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-network w-4 h-4" aria-hidden="true"><rect x="16" y="16" width="6" height="6" rx="1"></rect><rect x="2" y="16" width="6" height="6" rx="1"></rect><rect x="9" y="2" width="6" height="6" rx="1"></rect><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path><path d="M12 12V8"></path></svg> */}
                            <div className=' w-4/5 mr-1 ml-1' style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</div>
                            {
                                props.isLogin?(
                                    <div className='w-2 h-2 rounded-full bg-green-500'></div>
                                ):(
                                    <div className='w-2 h-2 rounded-full bg-red-700'></div>
                                )
                            }
                            
                        </button>
                    )
                }
                
            </div>

           
            
            {/* <div  className=' w-6/12 text-mtc-font-color1 flex flex-row justify-center items-center text-base'>
                {
                    props.address.length===0?(
                        <button onClick={connectWallet} className=' w-full h-8 border border-head-border text-head-border rounded-full  font-extrabold text-sm text-center'>{t('head.连接钱包')}</button>
                    ):(
                        <button className=' w-full h-8 border border-head-border text-head-border rounded-full  font-extrabold text-xs text-center px-2' style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</button>
                    )
                }
                
            </div> */}
            
           
            
        </div>
        <div className=' w-full lg:w-1/3 flex flex-row justify-center bg-black -mt-2'>
        {/* <img alt='rr' className='z-20 fixed  top-16' src={require('../../assets/icon/kuangtop750.png')} style={{"width":"750px"}}></img> */}
        </div>

        <CSSTransition
                    in={props.flash&&!props.isLogin}
                    unmountOnExit={true}
                    classNames='coder'
                    timeout={500}
                    appear
                    onEnter={(e) => console.log('')}
                    onEntering={(e) => console.log('')}
                    onEntered={(e) => console.log('')}
                    onExit={(e) => console.log('')}
                    onExiting={(e) => console.log('')}
                    onExited={(e) => console.log('')}>
                    <div className=' w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0  bg-opacity-90  zindex999999 '>
                        <div className='  mx-4 mt-24  px-1 py-4   bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)]'>
                                    <div className='w-full relative mt-5 flex flex-row justify-center items-center text-title'>
                                        
                                        {/* <CloseOutlined onClick={()=>props.setFlash(false)} className=' absolute right-0  text-xl' /> */}
                                    </div>
                                    <div className=' mt-12 flex flex-row justify-center'>
                                        <img alt='rr' className=' mr-1 ' src={require('../../assets/bcb/logo.png')} style={{"width":"40px"}}></img>
                                    </div>
                                    <div html className=' w-full mt-4 flex flex-row justify-center font-bold text-base text-white'>
                                       <span style={{"color":"#ff6600"}}></span> {t('head.需绑定推荐地址,才能激活!')}
                                    </div>
                                    <div className=' w-full  px-2 mt-5  flex flex-row justify-center items-center'>
                                        <div className=' w-full py-3 px-3 h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                            {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                            
                                            <span className=' text-base text-gray-900 lessAddress'>{props.isLogin?puser:props.pAddress}</span>
                                        </div>
                                        {/* <img onClick={par1} alt='rr' className=' ml-1 ' src={require('../../assets/icon/left.png')} style={{"width":"30px"}}></img> */}
                                    </div>
                                    <div onClick={_register} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className=' w-40 h-10 mt-4 mb-4 rounded-md mx-auto flex flex-row justify-center items-center bg-gradient-to-b from-[#0161F6] to-[#030D54]'>
                                        {/* <img alt='rr' className=' mr-2 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"20px"}}></img> */}
                                        <span className=' text-sm font-bold text-gray-100'>{t('head.确定绑定!')}</span>
                                    </div>
                                    {/* <div className=' w-1/2 h-14 mt-4 mx-auto flex flex-row justify-center items-center rounded-3xl bg-gradient-to-r from-black1b  to-black1b'>
                                        
                                        <span className=' text-lg font-bold text-gray-500'>{t('p.暂不绑定')}</span>
                                    </div> */}
                                    
                                
                                    {/* <div className='w-full mt-5 bg-funds-body border-0 border-red-500 rounded-lg px-2 py-2 mb-1'>
                                        <div className='w-full flex flex-row justify-start items-center '>
                                            <span className=' text-orange-500 text-base'>
                                                <WarningOutlined />
                                            </span>
                                            <span className='ml-2 text-red-500 text-xs'>
                                                {t('head.规则说明1')}
                                            </span>
                                        </div>
                                       
                                    </div> */}
        
                                </div>
                            </div>
                    </CSSTransition>
      
        <CSSTransition
            in={isShowMenu}
            unmountOnExit={true}
            classNames='head'
            timeout={1000}
            appear
            onEnter={(e) => console.log('开始进入动画')}
            onEntering={(e) => console.log('执行进入动画')}
            onEntered={(e) => console.log('进入动画结束')}
            onExit={(e) => console.log('开始离开动画')}
            onExiting={(e) => console.log('正在离开动画')}
            onExited={(e) => console.log('离开动画结束')}>
            <div className='w-full lg:w-1/4 h-screen fixed left-0 top-0 pt-16 text-white shadow-md z-20 overflow-y-auto' style={{ backgroundColor: "#1C182C" }}>
  <div className="px-4">
    {/* 语种折叠面板 */}
    <Collapse defaultActiveKey={['7']} expandIconPosition="right" ghost accordion>
      <Panel header={t('head.语种')} key="7" className='text-sm text-gray-100' style={{ color: "#ffffff" }}>
        <div className="grid grid-cols-3 gap-y-3 gap-x-2">
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("en");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q1.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">ENGLISH</span>
          </div>
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("in");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q6.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">عربي</span>
          </div>
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("zh");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q3.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">繁体中文</span>
          </div>
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("rr");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q2.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">Русский</span>
          </div>
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("kr");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q5.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">한국</span>
          </div>
          <div className='flex flex-row items-center cursor-pointer' onClick={()=>{changeLan("jp");setIsShowMenu(false)}}>
            <img alt='rr' className='mr-2' src={require('../../assets/qi/q7.png')} style={{width:"20px",height:"20px"}}/>
            <span className="text-xs text-gray-100">日本語</span>
          </div>
        </div>
      </Panel>
    </Collapse>

    <div className="w-full h-[1px] my-4 bg-slate-400/20"></div>

    {/* 导航菜单 */}
    <div className="space-y-1">
      <Link
        to="/"
        onClick={showMenu}
        className='text-gray-100 flex flex-row items-center justify-between px-3 py-3 rounded-xl hover:bg-[#E05470]/15 transition-all'
      >
        <div className="flex items-center">
          <HomeOutlined style={{fontSize:16, color:'#E05470'}} className="mr-3"/>
          <span>{t('head.首页')}</span>
        </div>
        <svg viewBox="64 64 896 896" focusable="false" data-icon="right" width=".6em" height=".6em" fill="currentColor" aria-hidden="true">
          <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
        </svg>
      </Link>

      <Link
        to="/invite"
        onClick={showMenu}
        className='text-gray-100 flex flex-row items-center justify-between px-3 py-3 rounded-xl hover:bg-[#E05470]/15 transition-all'
      >
        <div className="flex items-center">
          <UserAddOutlined style={{fontSize:16, color:'#E05470'}} className="mr-3"/>
          <span>{t('head.我的推广')}</span>
        </div>
        <svg viewBox="64 64 896 896" focusable="false" data-icon="right" width=".6em" height=".6em" fill="currentColor" aria-hidden="true">
          <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
        </svg>
      </Link>

      <Link
        to="/invite1"
        onClick={showMenu}
        className='text-gray-100 flex flex-row items-center justify-between px-3 py-3 rounded-xl hover:bg-[#E05470]/15 transition-all'
      >
        <div className="flex items-center">
          <ShareAltOutlined style={{fontSize:16, color:'#E05470'}} className="mr-3"/>
          <span>{t('head.我的分享')}</span>
        </div>
        <svg viewBox="64 64 896 896" focusable="false" data-icon="right" width=".6em" height=".6em" fill="currentColor" aria-hidden="true">
          <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
        </svg>
      </Link>

      <Link
        to="/allocation"
        onClick={showMenu}
        className='text-gray-100 flex flex-row items-center justify-between px-3 py-3 rounded-xl hover:bg-[#E05470]/15 transition-all'
      >
        <div className="flex items-center">
          <WalletOutlined style={{fontSize:16, color:'#E05470'}} className="mr-3"/>
          <span>{t('mint.申购额度')}</span>
        </div>
        <svg viewBox="64 64 896 896" focusable="false" data-icon="right" width=".6em" height=".6em" fill="currentColor" aria-hidden="true">
          <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
        </svg>
      </Link>
    </div>
  </div>
</div>

            </CSSTransition>
        

       
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{
        setLan(value){
            const action ={type:"setLan",value:value}
            dispatch(action)
        },
        setAddress(value){
            const action ={type:"setAddress",value:value}
            dispatch(action)
        },
        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },
        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Head);
